import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';


@Injectable()
  export class LoggingService {
  
    constructor() {
    }

    logEntryDevToConsole(message: string){
        if(environment.production == false){
        }
    }

    logEntryDevToDB(message: string){
        if(environment.production == false){
            //todo insert REST call to log entry to DB for development tasks only
        }
    }

    logErrorDevToDB(message: string){
        if(environment.production == false){
            //todo insert REST call to log error entry to DB for development tasks only
        }
    }

    logCriticalErrorToDB(message: string){
        
            //todo insert REST call to log critical errors
        
    }


   
}